import { strlen, verifyHttpsUrl } from "@/utilities/common";
import { getDecimalNumber } from "@/utilities/number";

export const getTargetLinkErrorMessage = (data: any, required?: boolean, name?: string) => {
  if (!required && !data) {
    return "";
  } else if (required && !data) {
    return `请输入${name || "跳转链接"}`;
  } else if (!verifyHttpsUrl(data)) {
    return "请输入正确的网址格式";
  } else if (data.length > 2048) {
    return `${name || "跳转链接"}最长2048个英文字符`;
  } else {
    return "";
  }
};

export const getTextErrorMessage = (data: any, required?: boolean, name?: string, length = 16) => {
  if (!required && !data) {
    return "";
  } else if (required && !data) {
    return `请输入${name || "标题"}`;
  } else if (strlen(data) > length) {
    return `${name || "标题"}不能超过${length}个英文字符`;
  }
  return "";
};

export const getPriceErrorMessage = (data: any, required: boolean, name: string) => {
  if (!required && !data) {
    return "";
  } else if (required && !data) {
    return `请输入${name || "价格"}`;
  } else if (isNaN(Number(data))) {
    return "请输入数字";
  } else if (getDecimalNumber(data) > 2) {
    return "最多保留两位小数";
  } else if (Number(data) > 5000000000) {
    return "最大支持50亿";
  } else {
    return "";
  }
};
